import React, { useState } from "react";
import EarlyAccess from "../components/app/common/EarlyAccess";
import Social, { ISocials } from "../components/app/common/Socials";
// import Testimonials from "../components/app/common/Testimonials";
import FindJobLayout from "../components/app/layout/FindJobLayout";
import ConsultancyHero from "../components/app/consultancy/ConsultancyHero";
import WhyChooseStaff from "../components/app/consultancy/WhyChooseStaff";
import WhyChooseConsulting from "../components/app/consultancy/WhyChooseConsulting";
import WhyChooseSolutions from "../components/app/consultancy/WhyChooseSolutions";
import MeetTeam, { ITeamMember } from "../components/app/common/MeetTeam";
import { BlurFade } from "../components/app/BlurFade";
import ContactFormModal from "../components/app/common/ContactModal";

const ConsultancyPage: React.FC = () => {
  const socialImages: string[] = [
    "/learning/socials/social-1.png",
    "/learning/socials/social-2.png",
    "/learning/socials/social-3.png",
    "/learning/socials/social-4.png",
    "/learning/socials/social-5.png",
  ];
  const socialLinks: ISocials[] = [
    {
      url: "/socials/social-facebook.svg",
      name: "Facebook",
      link: "https://www.facebook.com/share/18nbHmNwtY/?mibextid=wwXIfr",
    },
    {
      url: "/socials/social-instagram.svg",
      name: "Instagram",
      link: "https://www.instagram.com/dwrecruitment?igsh=MWxqZWQ4NTVkNDBvbA==",
    },
  ];

  const teamMembers: ITeamMember[] = [
    {
      name: "Nancy Sharma",
      role: "Backend & Vendor Operations",
      description:
        "There are many variations of passages of Lorem Ipsum available",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/consulting/meet/nancy.png",
    },
    {
      name: "Supriya",
      role: "Senior Executive Corporate Relation",
      description:
        "There are many variations of passages of Lorem Ipsum available",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/consulting/meet/supriya.png",
    },
    {
      name: "Savneet Kaur",
      role: "Sourcing Manager North",
      description:
        "There are many variations of passages of Lorem Ipsum available",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/consulting/meet/savneet.png",
    },
  ];
  const leftMember = {
    name: "Vivek Sama",
    role: "Global Business Director",
    description:
      "There are many variations of passages of Lorem Ipsum available",
    linkedin: "http://linkedin.com/in/vivek-sama-a73809b",
    image: "/consulting/meet/vivek.png",
  };
  const [showContactModal, setShowContactModal] = useState<boolean>(false);

  const toggleShowContactModal = () => {
    setShowContactModal((prev) => !prev);
  };

  return (
    <div>
      <section
        className="p-5 sm:p-7 lg:p-10"
        style={{
          backgroundImage: "url(/skill/landing-hero.svg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <BlurFade delay={0.25} inView>
          <ConsultancyHero />
        </BlurFade>
      </section>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16 xl:px-20 flex flex-col mt-[8rem] md:mt-[13rem] md:flex-row xl:mt-[21rem] gap-10">
          <div className=" hidden md:flex flex-col p-3 xl:p-0 md:mb-10 lg:mb-0 md:flex-row gap-5 sm:gap-10 justify-center items-center">
            <div className="flex justify-center items-center md:w-56 xl:w-[23rem]">
              <img alt="" src="/dots.svg" className="w-56 xl:w-[23rem]" />
            </div>
          </div>
          <div className="flex-1 xl:justify-start justify-center xl:flex-1">
            <div className="flex flex-col justify-between gap-5 lg:ml-20 xl:ml-24 xl:pt-4">
              <div className=" max-w-3xl text-xl xl:space-y-9 sm:text-xl md:text-2xl lg:text-3xl xl:text-[3.5rem]">
                <h4 className="-mx-1">Your Trusted Partner for</h4>
                <h4>Workforce Excellence</h4>
              </div>
              <p className="max-w-2xl xl:pt-4 xl:max-w-[52rem] text-sm sm:text-base font-light xl:leading-normal xl:text-[28px]">
                At Dream Weavers, we understand the importance of having the
                right people in the right roles. Our recruitment and staffing
                solutions are tailored to meet your business needs, ensuring you
                have the workforce required to thrive in a competitive world.
              </p>
            </div>
          </div>
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16 xl:pb-2 xl:px-28 bg-[#F4F4F4]  ">
          <WhyChooseStaff />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16 xl:px-28 bg-[#ECEAEA]  ">
          <WhyChooseConsulting />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16 xl:px-28">
          <WhyChooseSolutions onOpenModal={toggleShowContactModal} />
        </section>
      </BlurFade>
      {/* <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 my-12 lg:p-16 xl:py-10 bg-[#F7F9FC]">
          <Testimonials
            title="Don't just take our word for it!"
            smallDecription="See the feedback of our Clients"
          />
        </section>
      </BlurFade> */}
      <BlurFade delay={0.25} inView>
        <section>
          {/* todo: add button url here */}
          <FindJobLayout
            title="Let's Build the Future Together"
            description="Guided by Values, Driven by Excellence. Discover the principles that define who we are and shape everything we do."
            buttonContent="Know About Us"
            buttonUrl="/aboutus"
            underlineUrl="/careers"
          />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView className="mt-10 lg:mt-16 xl:mt-20">
        <section className="p-5 sm:p-7 lg:p-16 xl:py-2 xl:px-28">
          <MeetTeam
            title="Meet the Recruitment and Staffing Team"
            description="dedicated to matching top talent with exceptional opportunities. With years of industry experience, our professionals bring a personalized approach, ensuring the best fit for both employers and job seekers. Trust us to streamline your hiring process and deliver outstanding results."
            teamMembers={teamMembers}
            leftMember={leftMember}
            hideDescription={true}
          />
        </section>
      </BlurFade>
      <section>
        <Social images={socialImages} socialLinks={socialLinks} />
      </section>
      <section
        className="px-5 sm:px-10 mt-10"
        style={{
          backgroundImage: "url('/home/early-access-bg.svg')",
        }}
      >
        <EarlyAccess />
      </section>
      <ContactFormModal
        isOpen={showContactModal}
        onClose={toggleShowContactModal}
      />
    </div>
  );
};

export default ConsultancyPage;
